import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { FolderOpen } from 'lucide-react';

export function PortfolioFilter({ value, onChange, onPortfolioChange }) {
  const { getHeaders, API } = useAuth();
  const [portfolios, setPortfolios] = useState([]);

  useEffect(() => {
    axios.get(`${API}/admin/portfolios`, { headers: getHeaders() })
      .then(res => setPortfolios(res.data))
      .catch(() => {});
  }, [API, getHeaders]);

  if (portfolios.length <= 1) return null;

  const handleChange = (v) => {
    const id = v === 'all' ? '' : v;
    onChange(id);
    if (onPortfolioChange) {
      const selected = portfolios.find(p => p.id === id);
      onPortfolioChange(selected || null);
    }
    // Emit portfolio change for navbar logo
    const selected = portfolios.find(p => p.id === id);
    window.dispatchEvent(new CustomEvent('portfolio-changed', { detail: selected || null }));
  };

  return (
    <div className="flex items-center gap-1.5" data-testid="portfolio-filter">
      <FolderOpen className="w-3.5 h-3.5 text-[#5C6B64]" />
      <Select value={value || 'all'} onValueChange={handleChange}>
        <SelectTrigger className="h-8 text-xs border-[#E2E8DF] w-[160px]" data-testid="portfolio-filter-trigger">
          <SelectValue placeholder="All Portfolios" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Portfolios</SelectItem>
          {portfolios.map(p => (
            <SelectItem key={p.id} value={p.id}>{p.name} ({p.outlet_count})</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
